import { FC, ReactNode } from 'react';

import { useShowDelayedLoading } from '@telialt/common-hooks/src/useShowDelayedLoading';

import { LoaderContainer, Spinner } from './Loader.styles';

type Props = {
    isLoading?: boolean;
    dataTest?: string;
    delay?: number;
    ariaLabel?: string;
    children?: ReactNode;
};

export const Loader: FC<Props> = ({ isLoading, dataTest, delay = 2000, ariaLabel, children }) => {
    const showLoader = useShowDelayedLoading(isLoading, delay);

    return (
        <>
            {showLoader && (
                <LoaderContainer role="status" data-test={dataTest || 'loading-spinner'} aria-label={ariaLabel}>
                    <Spinner aria-hidden={true} />
                </LoaderContainer>
            )}
            {children}
        </>
    );
};
